export default function(user) {
    if(user) {
        return user.firstName + ' ' + user.lastName;
    }   
}